import { takeEvery, put, call } from "redux-saga/effects";
import {
  addPersonToList,
  addPersonToListFailure,
  addPersonToListSuccess,
  deletePerson,
  deletePersonFailure,
  deletePersonSuccess,
  editPerson,
  editPersonFailure,
  editPersonSuccess,
  getPersonList,
  setPersonList
} from "../actions/personListAction";
import { getOrderPersonsRequest } from "../../api/personList/getOrderPersonsRequest";
import { addPersonToListRequest } from "../../api/personList/addPersonToListRequest";
import { message } from "antd";
import { deletePersonRequest } from "../../api/personList/deletePersonRequest";
import { editPersonRequest } from "../../api/personList/editPersonRequest";

function* getOrderPersonSaga(action) {
  try {
    const orderId = action.payload.orderId;
    const pagination = action.payload.pagination;
    const sort = action.payload.sort;
    const personTypeKey = action.payload.personTypeKey;
    const response = yield call(
      getOrderPersonsRequest,
      orderId,
      pagination,
      sort,
      personTypeKey
    );
    if (response.status === 200) {
      yield put(setPersonList(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* addPersonToListSaga(action) {
  try {
    const orderId = action.payload.orderId;
    const personTypeKey = action.payload.personTypeKey;
    const response = yield call(
      addPersonToListRequest,
      orderId,
      action.payload
    );
    if (response.status === 200) {
      yield put(addPersonToListSuccess());
      // В случае удачного добавления персоны - запрашиваем обновленный список персон
      const list = yield call(
        getOrderPersonsRequest,
        orderId,
        null,
        null,
        personTypeKey
      );
      if (list.status === 200) {
        yield put(setPersonList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(addPersonToListFailure({ message: errorMessage, errors }));
  }
}

function* deletePersonSaga(action) {
  console.log(action);
  try {
    const { orderId, person_id, personTypeKey } = action.payload;
    const response = yield call(deletePersonRequest, orderId, person_id);
    if (response.status === 200) {
      yield put(deletePersonSuccess());

      // В случае удачного удаления персоны - запрашиваем обновленный список персон
      const list = yield call(
        getOrderPersonsRequest,
        orderId,
        null,
        null,
        personTypeKey
      );
      if (list.status === 200) {
        yield put(setPersonList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(deletePersonFailure({ message: errorMessage, errors }));
  }
}

function* editPersonSaga(action) {
  try {
    const { orderId, person_id, personTypeKey } = action.payload;
    const response = yield call(
      editPersonRequest,
      orderId,
      person_id,
      personTypeKey,
      action.payload
    );
    if (response.status === 200) {
      yield put(editPersonSuccess());

      // В случае удачного редактирования персоны - запрашиваем обновленный список персон
      const list = yield call(
        getOrderPersonsRequest,
        orderId,
        null,
        null,
        personTypeKey
      );
      if (list.status === 200) {
        yield put(setPersonList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(editPersonFailure({ message: errorMessage, errors }));
  }
}

export function* orderPersonWatcher() {
  yield takeEvery(getPersonList.toString(), getOrderPersonSaga);
  yield takeEvery(addPersonToList.toString(), addPersonToListSaga);
  yield takeEvery(deletePerson.toString(), deletePersonSaga);
  yield takeEvery(editPerson.toString(), editPersonSaga);
}
